import React from 'react';

import { Button } from '@sololearnorg/sol';
import useStyles from 'isomorphic-style-loader/useStyles';
import { Container, i18n } from '../../../../symphony';

import { SlCodeBitsContext } from '../../global-constants';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../global-interface';

import s from './NewCode.scss';

export function NewCode() {
	useStyles(s);
	const onClick = () => {
		const { actions$ } = Container.take(SlCodeBitsContext, SlActions);

		actions$.next({
			type: ActionType.OnNewCodeClick,
			requestType: RequestType.Parallel,
		});
	};

	return (
		<div className="sl-code-bits-new-code">
			<Button
				type="button"
				className="sl-code-bits-new-code__button"
				size="m"
				onClick={onClick}
			>
				{i18n.t('web-code.new-code-cta')}
			</Button>
			<Button
				type="button"
				className="sl-code-bits-new-code__button-small"
				size="s"
				onClick={onClick}
			>
				{i18n.t('web-code.new-code-cta')}
			</Button>
		</div>
	);
}
